const stats = [
  { value: '19+', label: 'Années d\'expérience' },
  { value: '2 500+', label: 'Clients satisfaits' },
  { value: '24/7', label: 'Disponibilité urgences' },
  { value: '100%', label: 'Certifié & assuré' },
];

const certifs = [
  { icon: 'ri-shield-check-line', label: 'Certifié NIBT/OIBT' },
  { icon: 'ri-award-line', label: 'Qualité ISO 9001' },
  { icon: 'ri-leaf-line', label: 'Partenaire SuisseEnergie' },
  { icon: 'ri-building-line', label: 'Agréé cantons GE, VD, FR' },
];

export default function PresentationAbout() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden" style={{ height: '460px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=professional%20team%20technicians%20electricians%20plumbers%20workers%20in%20uniform%20Geneva%20Switzerland%20modern%20office%20building%20clean%20white%20background%20corporate%20team%20photo&width=680&height=460&seq=pres-about-01&orientation=landscape"
                alt="Équipe CasaReNovaPlus Neuenegg"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Badge flottant */}
            <div className="absolute -bottom-5 -right-5 bg-white rounded-2xl p-5 border border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-brand-500 rounded-xl">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <p className="text-xs text-gray-400 font-medium">Basé à</p>
                  <p className="text-sm font-bold text-gray-900">Neuenegg, Fribourg</p>
                  <p className="text-xs text-gray-400">Austrasse 95</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right: content */}
          <div>
            <span className="inline-block text-xs font-bold uppercase tracking-widest text-brand-500 mb-3">Qui sommes-nous</span>
            <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-5 leading-tight">
              L'expertise rénovation<br />au service de Neuenegg
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-5">
              Fondée à Neuenegg, CasaReNovaPlus est une entreprise multi-technique qui accompagne particuliers, entreprises et régies dans tous leurs projets de rénovation, d'installation et de maintenance. Notre équipe de techniciens certifiés intervient rapidement dans tout le canton de Fribourg et en Suisse romande.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              Notre force : un seul interlocuteur pour tous vos corps de métier. Rénovation, électricité, plomberie, chauffage, ventilation — nous coordonnons tout pour vous simplifier la vie et garantir des travaux de qualité dans les délais.
            </p>

            {/* Certifications */}
            <div className="grid grid-cols-2 gap-3 mb-8">
              {certifs.map((c) => (
                <div key={c.label} className="flex items-center gap-3 bg-white border border-gray-100 rounded-xl px-4 py-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-brand-50 rounded-lg shrink-0">
                    <i className={`${c.icon} text-brand-500 text-sm`}></i>
                  </div>
                  <span className="text-xs font-semibold text-gray-700">{c.label}</span>
                </div>
              ))}
            </div>

            {/* Stats */}
            <div className="grid grid-cols-4 gap-4">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <p className="text-2xl font-black text-brand-500">{s.value}</p>
                  <p className="text-xs text-gray-500 mt-1 leading-tight">{s.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
